import { ISortSelectOption } from 'src/components/filter/types/filter.types'

const useProductPublicSelectionOptions = () => {
  const selectionValues: ISortSelectOption[] = [
    { value: 'all', label: 'all' },
    {
      label: 'Yes',
      value: 'Yes',
    },
    {
      label: 'No',
      value: 'No',
    },
  ]

  return {
    selectName: 'product-filter-public.v',
    queryParamName: 'public',
    items: selectionValues,
  }
}

export { useProductPublicSelectionOptions }
